// 数値として解釈できない値（null / undefined / 空文字 / 数値化できない文字列）を未選択扱いにする
const isNotNumeric = (value?: number | string | null): boolean =>
  value === null || value === undefined || value === '' || Number.isNaN(Number(value))

// 週の稼働時間が未選択のときは空文字を返し、1か月で稼働可能な累計時間を空欄で表示する
export const toWorkHoursPerMonth = (workHoursPerWeek?: number | string | null): number | '' => {
  if (isNotNumeric(workHoursPerWeek)) return ''

  return Number(workHoursPerWeek) * 4
}

// 累計時間が空欄のときは希望報酬額幅も空欄で表示する
export const toDesiredSalaryRange = (
  workHoursPerMonth: number | string | null | undefined,
  desiredHourlySalary: number
): string => {
  if (isNotNumeric(workHoursPerMonth)) return ''

  return (Number(workHoursPerMonth) * desiredHourlySalary).toLocaleString()
}
